// src/components/VerseSidebarLayout.tsx
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Sidebar from '../sidebar/sidebar';
import VerseSidebar from './VerseSidebar';   // painel de versículos
import Topbar from '../topbar/Topbar';
import api from '../../services/api';
import { PendingPaymentProvider } from '../modal/PendingPaymentContext';
import PendingPaymentPopup from '../modal/PendingPaymentPopup';
import { SaleDueProvider } from '../modal/SaleDueContext';
import SaleDuePopup from '../modal/SaleDuePopup';
import ImpersonationBanner from '../ImpersonationBanner';

const VerseSidebarLayout: React.FC = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [hasPending, setHasPending] = useState(false);
    const [overdueTasks, setOverdueTasks] = useState(0);

    const location = useLocation();

    // verifica pendências para o sino da topbar
    useEffect(() => {
        const check = () => {
            api.get<boolean>('/pending/check-pending')
                .then(res => setHasPending(res.data))
                .catch(() => setHasPending(false));
        };
        check();
        const iv = setInterval(check, 5 * 60 * 1000);
        return () => clearInterval(iv);
    }, []);

    // tarefas vencidas sem conclusão — sino de tarefas na topbar.
    // Também revalida a cada navegação, para o contador não ficar velho
    // depois que o usuário reabre ou cancela tarefas no modal.
    useEffect(() => {
        const check = () => {
            api.get<{ total: number }>('/task/check-overdue')
                .then(res => setOverdueTasks(res.data.total ?? 0))
                .catch(() => setOverdueTasks(0));
        };
        check();
        const iv = setInterval(check, 5 * 60 * 1000);
        return () => clearInterval(iv);
    }, [location.pathname]);

    return (
        // O provider precisa envolver topbar e modal: os dois leem a MESMA
        // lista de mensalidades em aberto, buscada uma única vez.
        <PendingPaymentProvider>
        <SaleDueProvider>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
                <ImpersonationBanner />

                <Box sx={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
                    {/* menu principal (escuro, recolhível) */}
                    <Sidebar collapsed={collapsed} />

                    {/* coluna direita: topbar + conteúdo */}
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                        <Topbar
                            onToggleSidebar={() => setCollapsed(c => !c)}
                            hasPending={hasPending}
                            overdueTasks={overdueTasks}
                        />

                        <Box sx={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
                            {/* área de conteúdo */}
                            <Box
                                sx={{
                                    flex: 1,
                                    p: '24px',
                                    overflowY: 'auto',
                                    background: 'var(--bg-gradient)',
                                }}
                            >
                                <Outlet />
                            </Box>

                            {/* painel de versículos */}
                            <VerseSidebar />
                        </Box>
                    </Box>

                    <PendingPaymentPopup />
                    <SaleDuePopup />
                </Box>
            </Box>
        </SaleDueProvider>
        </PendingPaymentProvider>
    );
};

export default VerseSidebarLayout;
